import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8061/api/v1/admin';
export const TOKEN_KEY = 'fw_admin_token';
export const USER_KEY = 'fw_admin_user';

const api = axios.create({ baseURL: API_BASE, headers: { 'Content-Type': 'application/json' }, timeout: 30000 });

api.interceptors.request.use(config => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// A 401 anywhere except the sign-in calls means the session ended: clear it and go to sign-in.
api.interceptors.response.use(
  response => response,
  error => {
    const url: string = error.config?.url || '';
    if (error.response?.status === 401 && !url.startsWith('/login')) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_KEY);
      if (window.location.pathname !== '/login') window.location.href = '/login?expired=1';
    }
    return Promise.reject(error);
  },
);

/** The server's message for a failed request, never a raw exception string. */
export function errorText(error: any, fallback = 'Something went wrong. Try again.'): string {
  const detail = error?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail) && detail[0]?.msg) return String(detail[0].msg).replace(/^Value error, /, '');
  if (error?.code === 'ERR_NETWORK') return "Can't reach the admin API. Is it running?";
  return fallback;
}

export default api;
